<template>
    <v-container>
        <v-card class="pa-3 ma-md-3">
            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <v-toolbar-title>
                    <h2>Seguimiento de obras</h2>
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-sheet tile height="54" class="d-flex">
                    <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>

                    <v-select
                        v-model="type"
                        :items="types"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined
                        hide-details
                        class="ma-2"
                        label="Mostrar"
                    ></v-select>

                    <v-text-field
                        width="100"
                        outlined
                        label="Mes"
                        dense
                        hide-details
                        class="ma-2"
                        disabled
                        :value="month_name"
                    ></v-text-field>

                    <v-text-field
                        outlined
                        label="Año"
                        dense
                        hide-details
                        class="ma-2"
                        disabled
                        :value="date.year"
                    ></v-text-field>

                    <v-spacer></v-spacer>
                    <v-btn icon class="ma-2" @click="$refs.calendar.next()">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-sheet>
                <v-sheet height="600">
                    <v-calendar
                        ref="calendar"
                        v-model="value"
                        :weekdays="weekday"
                        :type="type"
                        :events="events"
                        :event-overlap-mode="mode"
                        :event-overlap-threshold="30"
                        :event-color="getEventColor"
                        @change="changeDate"
                        @click:more="viewDay"
                        @click:date="viewDay"
                    >
                        <template v-slot:event="{ event }">
                            <router-link
                                :to="{ path: `/guardar-orden?id=${event.id}` }"
                            >
                                <div class="pl-1 white--text">
                                    {{ event.name }}
                                </div>
                            </router-link>
                        </template>
                    </v-calendar>
                </v-sheet>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import moment from "moment";
export default {
    data: () => ({
        type: "month",
        types: [
            {
                value: "month",
                label: "Mes",
            },
            {
                value: "week",
                label: "Semana",
            },
            {
                value: "day",
                label: "Día",
            },
        ],
        mode: "stack",
        weekday: [0, 1, 2, 3, 4, 5, 6],
        value: "",
        date: {
            month: null,
            year: null,
        },
        events: [],
        colors: [
            "  blue",
            "indigo",
            "deep-purple",
            "cyan",
            "green",
            "orange",
            "grey darken-1",
        ],
    }),
    created() {
        moment.locale("es");
    },
    watch: {
        date: {
            deep: true,
            handler(n) {
                console.log(n);
                this.getOrdenes(n);
            },
        },
    },

    methods: {
        viewDay({ date }) {
            this.value = date;
            this.type = "day";
        },
        changeDate(e) {
            this.date.month = e.start.month;
            this.date.year = e.start.year;
        },

        getOrdenes(date) {
            axios
                .get(`api/get-seguimiento-by-date/${date.month}/${date.year}`)
                .then(
                    (res) => {
                        this.events = res.data;
                    },
                    (res) => {}
                );
        },

        getEventColor(event) {
            return event.color; //this.colors[this.rnd(0, 6)]
        },

        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a;
        },
    },
    computed: {
        month_name() {
            return moment(this.date.month, "M").format("MMMM");
        },
    },
};
</script>
